import Vue from 'vue';

export default {
  state: {
    channels: [],
  },
  getters: {
    channels(state) {
      return state.channels;
    },
    channel: state => id => state.channels.find(item => item.id === id) || {},
    channelName: state => name => state.channels.find(item => item.channel === name) || {},
  },
  mutations: {
    SET_CHANNELS(state, payload) {
      state.channels = payload;
    },
  },
  actions: {
    GET_CHANNELS(context) {
      return Vue.axios.get('channels').then((response) => {
        context.commit('SET_CHANNELS', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/channels.js